export const SM = () => {
  return (
    <>
      <g clipPath="url(#clip0_1073_11912)">
      <g clipPath="url(#clip1_1073_11912)">
      <rect width="96" height="48" transform="matrix(-1 8.74228e-08 8.74228e-08 1 96 0)" fill="white"/>
      <rect width="96" height="48" transform="matrix(-1 8.74228e-08 8.74228e-08 1 96 48)" fill="#44BCEF"/>
      <circle cx="48" cy="48" r="12" fill="#EFD444"/>
      </g>
      </g>
      <rect x="2" y="2" width="92" height="92" rx="46" stroke="white" strokeOpacity="0.15" strokeWidth="4"/>
      <defs>
      <clipPath id="clip0_1073_11912">
      <rect width="96" height="96" rx="48" fill="white"/>
      </clipPath>
      <clipPath id="clip1_1073_11912">
      <rect width="96" height="96" rx="24" fill="white"/>
      </clipPath>
      </defs>
    </>
  )
}
